import React from "react";
import LoginForm from "../../components/auth/login/Login";

export default function Login() {
  return <LoginForm />;
}
